function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(param);
  return value ? value.replace(/[{}]/g, "") : value;
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

export function buildAdvancedMatching() {
  const hashedEmail = getQueryParam("em");
  const hashedPhone = getQueryParam("ph");

  const advancedMatching = {};
  if (hashedEmail !== "Not Provided" && hashedEmail) {
    advancedMatching.em = hashedEmail;
  }
  if (hashedPhone !== "Not Provided" && hashedPhone) {
    advancedMatching.ph = hashedPhone;
  }
  return advancedMatching;
}

export function sendEventToServer(
  advancedMatching,
  eventName,
  customDataPayload = {}
) {
  // reading _fbp & _fbc from browser cookies
  const fbp = getCookie("_fbp");
  const fbc = getCookie("_fbc");

  const eventData = {
    eventName,
    customDataPayload,
    userData: {
      emails: advancedMatching.em ? [advancedMatching.em] : [],
      phones: advancedMatching.ph ? [advancedMatching.ph] : [],
      fbp,
      fbc,
    },
  };

  const url =
    "https://itp-conversion-api-production.up.railway.app/track-event";

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(eventData),
  })
    .then((response) => response.json())
    .then((data) => console.log("Success:", data))
    .catch((error) => console.error("Error:", error));
}
